const doc = [({"da":({"models":({"number_of_students_csv":({"isnt_a_csv_file":"med endelsen %{ext} og indholdstypen %{content_type} er ikke en CSV"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;